// Vendor scripts
import 'bootstrap'
import '../src/fontawesome-pro/css/all.min.css'; //-6.4.2-web

// Vue
import './vue/vue.js'

// Custom scripts
window.initMap = require('./scripts/map').default;
import './scripts/accordion-anchor'
import './scripts/accordion-search'
import './scripts/alert'
import './scripts/collapse-prevent-close'
import './scripts/font-icon-resizer'
import './scripts/header'
import './scripts/image-caption-toggle'
import './scripts/image-modal'
import './scripts/swiper-config'
import './scripts/tab-anchor'
import './scripts/video-modal'
import './scripts/leaving-site'
import './scripts/header-scrolling-patch'
import './scripts/subnav-detect-active'
import './scripts/popover'
import './scripts/emma-form'
import './scripts/gated-content'
import './scripts/tabbed-content-section'
